import React, { Fragment, useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import PropTypes from 'prop-types';
import { loginVirtualScreen } from '../../actions/virtualscreen';
import { connect } from 'react-redux';
import Spinner from '../layout/Spinner';
import { setAlert } from '../../actions/alert';
import { GrLaunch } from 'react-icons/gr';

const LoginVirtualScreen = ({
  loginVirtualScreen,
  auth,
  setAlert,
  checkLicense
}) => {
  const [formData, setFormData] = useState({
    code_session: '',
    emailUser: `${auth.user.email}`
  });
  const [launchInstance, setLaunchInstance] = useState(false);
  const { t } = useTranslation();
  const { code_session, emailUser } = formData;

  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value.toUpperCase() });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (code_session.length < 6) {
      setAlert(<Trans>{t('code_short')}</Trans>, 'warning');
    } else {
      setLaunchInstance(true);
      const res = await loginVirtualScreen(code_session, emailUser);
      setFormData({ ...formData, code_session: '' });
      if (res && res.status === 200) {
        setTimeout(() => {
          window.open(`/#/supportaccess/${res.data.id}`, '_blank');
          setLaunchInstance(false);
        }, 2500);
      } else {
        setLaunchInstance(false);
        switch (res.status) {
          case 403:
            setAlert(
              <Trans>{t('alert_error_code_or_entity')}</Trans>,
              'danger'
            );
            break;
          case 409:
            setAlert(<Trans>{t('alert_instance_exists')}</Trans>, 'danger');
            break;
          case 500:
            setAlert(<Trans>{t('alert_error_server')}</Trans>, 'danger');
            break;
          case 504:
            setAlert(
              <Trans>{t('alert_error_time_response_server')}</Trans>,
              'danger'
            );
            break;
          default:
            setAlert(<Trans>{t('alert_error')}</Trans>, 'danger');
        }
      }
    }
  };

  return (
    <Fragment>
      {!(
        auth &&
        auth.user &&
        (auth.user.rights === 'admin' || checkLicense === true)
      ) ? (
        <Spinner />
      ) : (
        <Fragment>
          {auth.user.rights !== 'ADV' ? (
            launchInstance ? (
              <section className="container">
                <p className="lead bg-warning my-2 p-2 text-center">
                  <GrLaunch /> {t('launching_instance')}
                  <GrLaunch />
                </p>
                <Spinner />
              </section>
            ) : (
              <section className="container">
                <Fragment>
                  <h1 className="large text-primary">{t('login_support')}</h1>
                  <div className="parent-flex">
                    <p className="lead">{t('loginsupport_lead')}</p>
                  </div>
                  <form className="form" onSubmit={(e) => onSubmit(e)}>
                    <div className="form-group">
                      <input
                        type="text"
                        placeholder={t('code_supportaccess')}
                        name="code_session"
                        value={code_session}
                        onChange={(e) => onChange(e)}
                        minLength="6"
                        maxLength="6"
                        autoComplete="off"
                        style={{
                          textTransform: 'uppercase',
                          borderColor:
                            code_session.length > 0 && code_session.length < 6
                              ? 'red'
                              : code_session.length === 6
                              ? 'green'
                              : '#ebebeb',
                          borderWidth: '2px'
                        }}
                      />
                    </div>
                    <input
                      type="submit"
                      className="btn btn-primary"
                      value={t('btnlogin')}
                    />
                  </form>
                </Fragment>
              </section>
            )
          ) : (
            <div className="d-flex justify-content-center align-items-center vh-100">
              <h4 className="large text-error text-center">
                {t('unauthorized_access')}
              </h4>
            </div>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

LoginVirtualScreen.propTypes = {
  loginVirtualScreen: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  checkLicense: PropTypes.bool.isRequired
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  checkLicense: state.license.checkLicense
});

export default connect(mapStateToProps, { setAlert, loginVirtualScreen })(
  LoginVirtualScreen
);
